import { useEffect, useState } from "react";

interface TableData {
    id: number;
    number_columns: number; // 2–4
    content1: string;
    content2: string;
    content3?: string;
    content4?: string;
}

function CustomTableComponent(props: TableData) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Collect all available columns
    const columns: string[] = [props.content1, props.content2];
    if (props.content3) columns.push(props.content3);
    if (props.content4) columns.push(props.content4);

    return (
        <div
            key={props.id}
            style={{
                display: "flex",
                flexDirection: windowWidth > 575 ? "row" : "column",
                gap: "16px",
                marginBottom: "100px",
                width: "fit-content", // container width fits content
                maxWidth: "90%", // optionally limit max width
                minWidth: "70%", // default minimum width
                marginLeft: windowWidth > 575 ? "auto" : "26px",
                marginRight: windowWidth > 575 ? "auto" : "0",
                justifyContent: windowWidth > 575 ? "space-between" : "flex-start",
                alignItems: "flex-start",
            }}
        >
            {columns.map((colHtml, index) => (
                <div
                    key={index}
                    style={{
                        flex: windowWidth > 575 ? 1 : undefined,
                        width: windowWidth > 575 ? undefined : "100%",
                    }}
                    dangerouslySetInnerHTML={{ __html: colHtml }}
                />
            ))}
        </div>
    );

}

export default CustomTableComponent;
